import React from 'react';
import { X, MapPin, Phone, MessageCircle, IndianRupee, Clock, Tag, Mail } from 'lucide-react';
import './ServiceDetailModal.css';

const ServiceDetailModal = ({ service, onClose }) => {
  const handlePhoneClick = () => {
    navigator.clipboard.writeText(service.phoneNumber);
    window.location.href = `tel:+91${service.phoneNumber}`;
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(`Hi, I found your service "${service.title}" on TravelB2B Hub. I'd like to know more.`);
    window.open(`https://wa.me/91${service.whatsappNumber}?text=${message}`, '_blank');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="service-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="detail-category">{service.category}</span>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-body detail-body">
          <h2 className="detail-title">{service.title}</h2>

          <div className="detail-meta">
            {(service.city || service.state || service.location) && (
              <div className="detail-meta-item">
                <MapPin size={16} />
                <span>{service.city ? `${service.city}, ${service.state}` : service.location}</span>
              </div>
            )}
            {service.companyName && (
              <div className="detail-meta-item">
                <strong>{service.companyName}</strong>
              </div>
            )}
            {service.price && (
              <div className="detail-meta-item detail-price">
                <IndianRupee size={16} />
                <span>{service.price}</span>
              </div>
            )}
          </div>

          <div className="detail-section">
            <h4 className="detail-section-title">Description</h4>
            <p className="detail-description">{service.description}</p>
          </div>

          <div className="detail-info">
            <div className="detail-info-item">
              <Tag size={16} />
              <span>Category: {service.category}</span>
            </div>
            <div className="detail-info-item">
              <Clock size={16} />
              <span>Listed on: {formatDate(service.createdAt)}</span>
            </div>
          </div>

          <div className="detail-contact">
            <h4 className="detail-section-title">Contact Information</h4>
            <div className="contact-buttons">
              <button className="contact-btn contact-btn-phone" onClick={handlePhoneClick}>
                <Phone size={20} strokeWidth={3} />
                <span className="contact-value">Call Now</span>
              </button>
              <button className="contact-btn contact-btn-whatsapp" onClick={handleWhatsAppClick}>
                <MessageCircle size={20} strokeWidth={3} />
                <span className="contact-value">WhatsApp</span>
              </button>
              {service.email && (
                <button className="contact-btn contact-btn-email" onClick={() => window.location.href = `mailto:${service.email}`}>
                  <Mail size={24} strokeWidth={2} />
                  <span className="contact-value">Email</span>
                </button>
              )}
            </div>
            {service.companyName && (
              <div className="company-info-detail">
                <h4 className="detail-section-title">About Company</h4>
                <p><strong>{service.companyName}</strong></p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetailModal;

